<template>
  <el-row class="login-page mt-3" justify="top">
    <el-col align="center" :span="24">
      <el-image class="logo mt-5 mb-3" src="images/logo-pixeon-icone.png" />

      <div class="login-form">
        <el-form @submit.prevent>
          <h3 class="mb-3">Nova Senha</h3>
          <el-form-item>
            <el-input
              input-style="border-radius: 3rem;"
              placeholder="Please input your new password"
              v-model.trim="authForm.password"
              show-password
            ></el-input>
            <button
              class="btn-login mt-3"
              type="primary"
              @click="onSubmit"
              round
            >
              Salvar
            </button>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { getAuth, updatePassword } from 'firebase/auth'
import { getDatabase, ref as dbRef, set } from 'firebase/database'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

import { ref } from 'vue'
export default {
  name: 'Login',
  setup () {
    const dbSet = getDatabase()
    const router = useRouter()

    const authForm = ref({
      password: ''
    })

    const onSubmit = async () => {
      const auth = getAuth()
      const user = auth.currentUser

      updatePassword(user, authForm.value.password).then(() => {
        set(dbRef(dbSet, `users/${user.uid}`), {
          firstAccess: false,
          email: user.email,
          active: true
        })

        ElMessage({
          message: 'Senha alterada com sucesso.',
          type: 'success'
        })
        router.push('/cultura')
      }).catch(() => {
        ElMessage({
          message: 'Não foi possível alterar a sua senha.',
          type: 'error'
        })
      })
    }

    return {
      onSubmit,
      authForm
    }
  }
}
</script>

<style lang="scss">
.login-page {
  justify-content: space-around;
  height: 100vh;
}
</style>

<style lang="scss" scoped>

.logo {
  height: 8rem;
}

.login-form {
  max-width: 40rem;
}

.btn-position {
  position: absolute;
  right: 0;
  top: -5px;
}
</style>
